// removed by extract-text-webpack-plugin
module.exports = {"overlay":"personalizationOverlayStyle__overlay__jvYAQ","isFlipped":"personalizationOverlayStyle__isFlipped__2vyjL","overlayArrow":"personalizationOverlayStyle__overlayArrow__x2hb5"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/home/components/personalization/personalizationOverlayStyle.scss
// module id = 3066
// module chunks = 22